import { CLIENT_LIST_SUCCESS } from 'salon/constants';
import {
  CLEAR_DEPOSIT_REFUNDED,
  CREATE_REFUND_FAILURE,
  CREATE_REFUND_REQUEST,
  CREATE_REFUND_SUCCESS,
  DEPOSIT_REFUND_CLIENT_FAILURE,
  DEPOSIT_REFUND_CLIENT_REQUEST,
  DEPOSIT_REFUND_CLIENT_SUCCESS,
  EMAIL_REFUND_RECEIPT_FAILURE,
  EMAIL_REFUND_RECEIPT_REQUEST,
  EMAIL_REFUND_RECEIPT_SUCCESS,
  GET_CLIENT_DEPOSIT_DETAILS_FAILURE,
  GET_CLIENT_DEPOSIT_DETAILS_REQUEST,
  GET_CLIENT_DEPOSIT_DETAILS_SUCCESS,
  GET_DEPOSIT_CLIENTS_LIST_FAILURE,
  GET_DEPOSIT_CLIENTS_LIST_REQUEST,
} from 'settings/balance-sheet/actions';

const initState = () => ({
  clientList: [],
  errorMessage: '',
  isFetching: false,
  clientViewData: {
    errorMessage: '',
    isFetching: false,
  },
  edit_client: {
    isFetching: false,
    error: null,
    data: null,
  },
  depositRefunded: null,
  emailSuccess: null,
});

const balanceSheetReducer = (state = initState(), action) => {
  if (!action?.type) return state;

  const { type, response, errorMessage, error } = action ?? {};
  const { edit_client: editClient } = state ?? {};

  if (type === 'CREATE_VOUCHER_SUCCESS') return { ...state, emailSuccess: false };
  if (type === CLIENT_LIST_SUCCESS) return { ...state, clientList: response, isFetchingClientList: false };
  if (type === CLEAR_DEPOSIT_REFUNDED) return { ...state, isFetching: false, depositRefunded: null };

  if (type === EMAIL_REFUND_RECEIPT_REQUEST) return { ...state, emailSuccess: null };
  if (type === EMAIL_REFUND_RECEIPT_SUCCESS) return { ...state, emailSuccess: true };
  if (type === EMAIL_REFUND_RECEIPT_FAILURE) return { ...state, emailSuccess: false };

  if (type === GET_DEPOSIT_CLIENTS_LIST_REQUEST) return { ...state, errorMessage: '' };
  if (type === GET_DEPOSIT_CLIENTS_LIST_FAILURE) return { ...state, errorMessage };

  if (type === CREATE_REFUND_REQUEST) return { ...state, errorMessage: '', isFetching: true };
  if (type === CREATE_REFUND_SUCCESS) return { ...state, isFetching: false, depositRefunded: response };
  if (type === CREATE_REFUND_FAILURE) return { ...state, isFetching: false, errorMessage };

  if (type === GET_CLIENT_DEPOSIT_DETAILS_REQUEST) {
    return {
      ...state,
      clientViewData: { response: null, errorMessage: '', isFetching: true },
    };
  }

  if (type === GET_CLIENT_DEPOSIT_DETAILS_SUCCESS) {
    return { ...state, clientViewData: { response, errorMessage: '', isFetching: false } };
  }
  if (type === GET_CLIENT_DEPOSIT_DETAILS_FAILURE) {
    return { ...state, clientViewData: { response: [], errorMessage, isFetching: false } };
  }

  if (type === DEPOSIT_REFUND_CLIENT_REQUEST) return { ...state, edit_client: { ...editClient, isFetching: true } };
  if (type === DEPOSIT_REFUND_CLIENT_SUCCESS) return { ...state, edit_client: { ...editClient, isFetching: false, data: response } };
  if (type === DEPOSIT_REFUND_CLIENT_FAILURE) {
    return { ...state, edit_client: { ...editClient, isFetching: false, error } };
  }

  return state;
};

export default balanceSheetReducer;
